import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function HomeTextile({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.3125 16.25V17.75C15.3125 19.5449 13.8574 21 12.0625 21H5.5C3.70507 21 2.25 19.5449 2.25 17.75V6.25C2.25 4.45507 3.70507 3 5.5 3H18V3.00397C20.1256 3.09807 21.8201 4.85116 21.8201 7V14.75C21.8201 15.5784 21.1485 16.25 20.3201 16.25H15.3201L15.3125 16.25ZM3.75 6.25C3.75 5.2835 4.5335 4.5 5.5 4.5H14.6974C14.1484 5.1848 13.8201 6.05405 13.8201 7V14.75H13.8125V16.25H3.75V6.25ZM3.75 17.75H13.8125C13.8125 18.7165 13.029 19.5 12.0625 19.5H5.5C4.5335 19.5 3.75 18.7165 3.75 17.75ZM17.8201 4.5C16.4394 4.5 15.3201 5.61929 15.3201 7V11.75H20.3201V7C20.3201 5.61929 19.2008 4.5 17.8201 4.5ZM20.3201 13.25H15.3201V14.75H20.3201V13.25Z"
                  fill={FillColor}/>
        </svg>
    )
}